import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {SplashComponent} from './splash/splash.component';
import {LandingComponent} from './landing/landing.component';
import {LoginComponent} from './login/login.component';
import {SignupComponent} from './signup/signup.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {UpdatePasswordComponent} from './update-password/update-password.component';
import { PreLoginAuthGuard } from '../core/guard/pre-login-auth.guard';

const routes: Routes = [
  {path: '', redirectTo: '/landing', pathMatch: 'full',canActivate: [PreLoginAuthGuard] },
  {path: 'splash', component: SplashComponent,canActivate: [PreLoginAuthGuard]},
  {path: 'landing', component: LandingComponent,canActivate: [PreLoginAuthGuard]},
  {path: 'login', component: LoginComponent,canActivate: [PreLoginAuthGuard],
    data: {
      meta: {
        featureName: 'Login',
      }
    }
  },
  {path: 'signup', component: SignupComponent,canActivate: [PreLoginAuthGuard],
    data: {
      meta: {
        featureName: 'Sign Up',
      }
    }
  },
  {path: 'resetPassword', component: ResetPasswordComponent,canActivate: [PreLoginAuthGuard],
    data: {
      meta: {
        featureName: 'Reset Password',
      }
    }
  },
  {path: 'updatePassword', component: UpdatePasswordComponent,canActivate: [PreLoginAuthGuard],
    data: {
      meta: {
        featureName: 'Update Password',
      }
    }
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PreLoginRoutingModule { }
